import { render, staticRenderFns } from "./company.vue?vue&type=template&id=370a4a29&scoped=true"
import script from "./company.vue?vue&type=script&lang=ts"
export * from "./company.vue?vue&type=script&lang=ts"
import style0 from "@/styles/editor.scss?vue&type=style&index=0&id=370a4a29&prod&lang=scss&scoped=true&external"
import style1 from "@/styles/list.scss?vue&type=style&index=1&id=370a4a29&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a4a29",
  null
  
)

export default component.exports